import Client from 'config/axios';
import posthog from 'posthog-js';

export const deleteAward = async (token: string, awardId: number) => {
  try {
    const { data } = await Client.delete(`award/${awardId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    posthog.capture('DeletedAward', {
      DeletedAward: data
    });
    return { data };
  } catch (response) {
    const result = response as any;
    return { errors: result.data };
  }
};
